<template>
    <div class='schoolList'>
        <myBanner :imgSrc="imgSrc"/>
        <div class="showPc">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/index' }">{{title}}</el-breadcrumb-item>
                <el-breadcrumb-item v-show="!searchFlag" :to="{ path: '/index' }">{{countryName}}</el-breadcrumb-item>
                <el-breadcrumb-item>院校列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="showMobile">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/index' }"><span @click="goIndex">{{title}}</span></el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index' }" v-show="!searchFlag"><span @click="goIndex2">详情</span></el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index' }" v-show="!searchFlag"><span @click="goIndex2">{{countryName}}</span></el-breadcrumb-item>
                <el-breadcrumb-item>院校列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="dashed"></div>
        </div>
        <TabChange v-if="!searchFlag" class="tabChange1" :tabList="tabList1" @tabClick="tabClick1" ref="tabChange1"/>
        <TabChange v-if="!searchFlag" class="tabChange" :tabList="tabList" @tabClick="tabClick" ref="tabChange"/>
        <el-table
            :data="tableData"
            stripe
            class="tableName">
            <el-table-column align="center" prop="sort" width="100px" label="学校排名"> </el-table-column>
            <el-table-column align="center" width="100px">
                <template slot-scope="scope">
                    <img class="schoolLogo" :src="url + scope.row.logo" alt="">
                </template>
            </el-table-column>
            <el-table-column align="center" width="230px" prop="chineseName" label="学校中文名"></el-table-column>
            <el-table-column align="center" prop="englishName" label="学校英文名"> </el-table-column>
            <el-table-column align="center" prop="position" label="位置"> </el-table-column>
            <el-table-column align="center" width="150px" label="操作"> 
                <template slot-scope="scope">
                <!-- scope.row：代表这一行数据的对象 -->
                    <span class="detail"  @click="goDetail(scope.row.id)">
                        查看详情
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <!-- 移动端列表 -->
        <div class="showMobile mobileWidth">
            <div class="mShoolList">
                <div class="schoolItem" v-for="(item2,index2) in tableData" :key="index2" @click="goDetail(item2.id)">
                    <div class="leftLogo">
                        <div class="logoCont">
                            <img :src="url + item2.logo" alt="">
                        </div>
                    </div>
                    <div class="rightTxt">
                        <div class="top">{{item2.chineseName}}</div>
                        <div class="top">{{item2.englishName}}</div>
                        <div class="bottom">学校排名：{{item2.sort}}</div>
                        <div class="bottom">位置：{{item2.position}}</div>
                    </div>
                </div>   
            </div>    
            <div class="noData" v-show="isNoData">暂无数据</div>
        </div>
        <div class="page" v-show="!isNoData">
            <el-pagination
            background
            :small="isSmall"
            layout="prev, pager, next"
            :total="total"
            @current-change="changePage"
            :page-size="this.pageSize"
            ref="pagination"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
    import { getDataMixin } from "common/mixin.js"
    import TabChange from "components/content/tabChange/TabChange"
    import { getReceptionList,getLearnStyleList, getProvinceList } from "network/home.js"

    export default {
        name:"schoolList",
        mixins:[getDataMixin],
        components:{
            TabChange
        },
        data(){
            return{
                imgSrc:[],
                title:'',
                type:2,
                current:1,
                pageSize:10,
                tableData: [],
                navData:"",
                total:0,
                mode:"",
                isSmall:false,
                tabList:[],
                tabList1:[],
                modeIndex:0,
                provinceId:"",
                provinceIndex:0,
                url:process.env.VUE_APP_WEB_URL,
                isNoData:false
            }
        },
        created(){
            if(this.currentQuery){
                this.current = this.currentQuery
                //动态改变页码上的分页
                this.$nextTick(() => {
                    this.$refs.pagination.internalCurrentPage = Number(this.current);
                })
            }
            if(this.modeQuery){
                this.mode = this.modeQuery
                this.modeIndex = this.getModeIndex
                this.$nextTick(() => {
                    this.$refs.tabChange.currentIndex = this.getModeIndex
                })
            }
            if(this.provinceIdQuery){
                this.provinceId = this.provinceIdQuery
                this.provinceIndex = this.getProvinceIndex
                this.$nextTick(() => {
                    this.$refs.tabChange1.currentIndex = this.getProvinceIndex
                })
            }
            this.getData()
            if(this.$IsMobile()){
                this.isSmall = true
            }else{
                this.isSmall = false
            }
        },
        methods:{
            getData(){
                this.navData = this.getNvData[this.getNavIndex - 1]
                if(this.navData){   
                    let bannerData = this.navData.themeBanners
                    if(bannerData.length && bannerData.length == 2){
                        for(let i in bannerData){
                            bannerData.push(bannerData[i])
                        }
                        this.imgSrc = bannerData
                    }else if(bannerData.length){
                        this.imgSrc = bannerData
                    }
                    this.title = this.navData.title
                    if(this.navData.title == "合作院校"){
                        this.type = 1
                    }else{
                        this.type = 2
                    }
                    this.getLearnStyleListData({
                        countryId:this.countryId,
                        levels:this.navData.levels,
                        type:this.type
                    })
                    // 获取州省
                    this.getProvinceListData({
                        countryId:this.countryId,
                        levels:this.navData.levels,
                        type:this.type
                    })
                    this.getReceptionListData({
                        current:this.current,
                        pageSize:this.pageSize,
                        mode:this.mode, //升学方式（1双录，2直升）
                        countryId:this.searchFlag ? '' : this.countryId,
                        levels:this.searchFlag ? [] : this.navData.levels,
                        type:this.type,
                        nature:"",
                        provinceId:this.provinceId,
                        keyword:this.getKeyword
                    })
                    
                }
            },
            tabClick(index,id){
                this.modeIndex = index
                this.mode = id
                this.current = 1
                //动态改变页码上的分页
                this.$nextTick(() => {
                    this.$refs.pagination.internalCurrentPage = Number(this.current);
                })
                this.getData()
            },
            tabClick1(index,id){
                this.provinceId = id
                this.provinceIndex = index
                this.current = 1
                //动态改变页码上的分页
                this.$nextTick(() => {
                    this.$refs.pagination.internalCurrentPage = Number(this.current);
                })
                this.getData()
            },
            // 获取院校列表
            getReceptionListData(data){
                getReceptionList(data).then(res=>{
                    if(res.data.records){
                        this.tableData = res.data.records
                        this.total = res.data.total
                    }else{
                        this.tableData =[]
                        this.dataInfo = {}
                    }
                    if(res.data.total == 0){
                        this.isNoData = true
                    }else{
                        this.isNoData = false
                    }
                })
            },
            // 获取学习方式
            getLearnStyleListData(data){
                getLearnStyleList(data).then(res=>{
                    if(res.data.length){
                        res.data.unshift({id: "", style: "全部"})
                        this.tabList = res.data
                    }
                })
            },
            // 获取州省
            getProvinceListData(data){
                getProvinceList(data).then(res=>{
                    if(res.data.length){
                        res.data.unshift({id: "", style: "全部"})
                        this.tabList1 = res.data
                    }
                })
            },
            changePage(pageIndex){
                this.current = pageIndex;
                this.getData()
            },
            goDetail(id){
                let link = ""
                if(this.getKeyword){
                    link = '/schoolDetail?id=' + id + '&keyword=' + this.getKeyword + '&flag=search' + '&current=' + this.current
                    this.$router.push(link)
                }else{
                    link = '/schoolDetail?id=' + id + '&current=' + this.current + '&mode=' + this.mode + '&modeIndex=' + this.modeIndex + '&provinceId=' + this.provinceId + '&provinceIndex=' + this.provinceIndex
                    this.$router.push(link)
                }
                localStorage.setItem('schoolDetailLink',link)
            },
            goIndex(){
                this.$store.state.mShowControlMeue = true
            },
            goIndex2(){
                this.$store.state.mShowControlMeue = false
            }
        },
        computed: {
            countryId(){
                return sessionStorage.getItem('countryId') ? sessionStorage.getItem('countryId') : ''
            },
            countryName(){
                return sessionStorage.getItem('countryName') ? sessionStorage.getItem('countryName') : '暂无'
            },
            titleName(){
                return this.type == 1 ? '合作院校' : '留学院校'
            },
            currentQuery(){
                return this.$route.query.current ? this.$route.query.current : 1 
            },
            modeQuery(){
                return this.$route.query.mode ? this.$route.query.mode : "" 
            },
            getModeIndex(){
                return this.$route.query.modeIndex ? this.$route.query.modeIndex : 0 
            },
            provinceIdQuery(){
                return this.$route.query.provinceId ? this.$route.query.provinceId : "" 
            },
            getProvinceIndex(){
                return this.$route.query.provinceIndex ? this.$route.query.provinceIndex : 0 
            },
            getKeyword(){
                return this.$route.query.keyword ? this.$route.query.keyword : "" 
            },
            searchFlag(){
                return this.$route.query.flag ? this.$route.query.flag : ""
            },
        },
        watch:{
            $route(){
                this.getReceptionListData({
                    current:1,
                    pageSize:this.pageSize,
                    mode:this.mode, //升学方式（1双录，2直升）
                    countryId:"",
                    levels:[],
                    type:this.type,
                    nature:"",
                    provinceId:'',
                    keyword:this.getKeyword
                })
                this.$nextTick(() => {
                    this.$refs.pagination.internalCurrentPage = Number(1);
                })
            },

        }
    }
</script>
<style scoped>
.el-table .detail{
    color:var(--color-main);
    cursor: pointer;
}
.el-table .schoolLogo{
    width:55px;
    margin:0 auto;
}
.page{
    text-align: center;
    margin-bottom: 40px;
}
.tabChange1,.tabChange{
    margin:15px auto 20px;
}
.el-breadcrumb {
    margin-bottom: 30px;
}
.tableName{
    width: 100%;
    margin:30px 0;
    border:1px solid rgba(229, 229, 229, 1);
}
@media screen and (max-width: 768px){
    .tabChange1,.tabChange{
        margin:0.3rem auto 0.3rem;
    }
    .el-breadcrumb {
        margin-bottom: 0.1rem;
    }
    .tableName{
        margin:0.5rem 0;
    }
    .el-table{
        display: none;
    }
    .mShoolList{
        margin-top:0.2rem;
    }
    .schoolItem{
        font-size: 0.24rem;
        margin-bottom: 0.2rem;
        background:var(--color-bg-main);
        padding:0.2rem;
        display: flex;
        align-items: center;
    }
    .leftLogo{
        margin-left:0.2rem;
        margin-right: 0.4rem;
    }
    .leftLogo .logoCont{
        width: 1.8rem;
        height:1.8rem;
        background:#fff;
    }
    .leftLogo .logoCont img{
        width:50%;
        position: relative;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
    }
    .rightTxt div{
        margin:0.2rem 0;
    }
    .schoolItem div.top{
        font-size:0.30rem;
    }
    .page{
        text-align: center;
        margin-bottom:0.5rem;
    }
    .noData{
        text-align: center;
        margin-top: 0.6rem;
    }
}
</style>